import { render, staticRenderFns } from "./TwoStepFooter.vue?vue&type=template&id=28295424&scoped=true"
import script from "./TwoStepFooter.vue?vue&type=script&lang=js"
export * from "./TwoStepFooter.vue?vue&type=script&lang=js"
import style0 from "./TwoStepFooter.vue?vue&type=style&index=0&id=28295424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28295424",
  null
  
)

export default component.exports